import { DataConflictRestoreSelection } from 'State/Game/DataConflictRestoreSelection';
import { DataConflictAutoResolveReason, PlayerDataLocation } from 'Utility/DataConflict/DataConflictsHelper';
import { IDataSet } from '../Track';
export class DataRestoreDataSet implements IDataSet {
    /** Which data */
    public restoreSelection: DataConflictRestoreSelection = undefined;
    public playerDataSelection: PlayerDataLocation = undefined;
    public dataConflictAutoResolved: number = undefined;
    public dataConflictAutoResolveReason: DataConflictAutoResolveReason = undefined;
}
